import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import DatePicker from "../table/DatePicker";
import { useState, useCallback } from "react";
import Sync from "../../services/sync";

const LogsDownload = ({ show, onCancel, deploymentId }) => {
    const [translate] = useTranslation();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const downloadLogs = useCallback(async (event) => {
        event.preventDefault();
        const start = new Date(startDate).getTime();
        const end = new Date(endDate).getTime();
        Sync.downloadLogs(deploymentId, start, end, true).then((detailsResponse) => window.open(detailsResponse, '_self'))
        Sync.downloadLogs(deploymentId, start, end).then((summaryResponse) => window.open(summaryResponse, '_self'));
    }, [startDate, endDate, deploymentId]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik>
                <Form onSubmit={(event) => downloadLogs(event)}>
                    <BootstrapModal.Header className="h5 text-secondary">
                        {translate("OTM_DOWNLOAD_LOGS")}
                    </BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <DatePicker label="OTM_START_DATE" onChange={setStartDate} initDate={null} />
                        <DatePicker label="OTM_END_DATE" onChange={setEndDate} initDate={null} css="mt-3" />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" disabled={!startDate || !endDate} className="btn-sm">{translate("OTM_DOWNLOAD")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default LogsDownload;